// The taskbar's open tabs, mirrored where DashboardLayout's <keep-alive> can
// read them (docs/specs/2026-10-06-bo-taskbar-fill-keepalive-design.md §3.2).
//
// A Vue.observable singleton rather than a vuex module: the strip's state lives
// in PageTaskbar on purpose (2026-10-03 spec §6). PageTaskbar is the only
// writer of `tabs`; everyone else reads.
//
// Imports `vue` and nothing else — src/routes/router.js imports this file, and
// anything reaching back into the route tree from here is a circular import.
import Vue from "vue";

export const taskbarLive = Vue.observable({
	// Latest copy of PageTaskbar's state.tabs. Read-only outside PageTaskbar.
	tabs: [],
	// Leaf route record path -> component name, filled by router.beforeResolve
	// (rememberRouteComponent in src/utils/keepAlive.js).
	components: {}
});

export function setLiveTabs(tabs) {
	taskbarLive.tabs = Array.isArray(tabs) ? tabs : [];
}

export function setLiveComponent(recordPath, name) {
	if (typeof recordPath !== "string" || recordPath === "") return;
	if (typeof name !== "string" || name === "") return;
	if (taskbarLive.components[recordPath] === name) return;
	// Vue.set: a key the observable has never seen must still be reactive.
	Vue.set(taskbarLive.components, recordPath, name);
}
